import { Box, Typography } from '@mui/material';
import { SwitchElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { tiktokDisclosureMessages as messages } from './tiktok-disclosure-messages';

/**
 * Row with the "Disclose video content" switch and its label only.
 * Helper description is rendered below this row in TiktokDisclosureSettings when disclosure is on.
 * Form-only; value is not sent to the TikTok API.
 */
export function TiktokDisclosureToggleRow({ enabled }: { enabled: boolean }) {
  const { $t } = useIntl();

  return (
    <Box mt={2} sx={{}}>
      <SwitchElement name="discloseVideoContent" label={$t(messages.discloseVideoContent)} />

      {!enabled && (
        <Typography variant="body2" color="text.secondary">
          {$t(messages.disclosureDescription)}
        </Typography>
      )}
    </Box>
  );
}
